import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import {
  BrowserRouter as Router, withRouter,
} from "react-router-dom";

import * as serviceWorker from './serviceWorker';

// @(withRouter as any)
// class ScrollToTop extends React.Component {
//   appEl: HTMLDivElement | undefined;
//   componentDidUpdate(prevProps: any) {
//     console.log('ScrollToTop')
//     if ((this.props as any).location !== prevProps.location) {
//       if(!this.appEl){
//         this.appEl = document.querySelector<HTMLDivElement>('#root > .App')!;
//       }
//       this.appEl.scrollTo(0, 0);
//     }
//   }

//   render() {
//     return this.props.children;
//   }
// }


// ReactDOM.render(
//   <Router>
//     <ScrollToTop>
//       <App />
//     </ScrollToTop>
//   </ Router>,
//   document.getElementById('root')
// );

ReactDOM.render(
  <Router>
    <App />
  </ Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



